const membersFilterOptions = [
  {
    value: 'active',
    text: 'Most contributions',
  },
  {
    value: 'newest',
    text: 'New',
  },
  {
    value: 'roles',
    text: 'Moderation team',
  },
  {
    value: 'similar-to-me',
    text: 'Similar to me',
  },
];

export default membersFilterOptions;
